export default {
    ORAL: 1,
    PARENTERAL: 2,
    LOCAL: 3,
    OUTRAS: 4,
    BUCAL: 5,
    CAPILAR: 6,
    DERMATOLOGICA: 7,
    EPIDURAL: 8,
    INALATORIA: 9,
    INALATORIA_POR_VIA_NASAL: 10,
    INALATORIA_POR_VIA_ORAL: 11,
    INTRA_ARTERIAL: 12,
    INTRA_ARTICULAR: 13,
    INTRADERMICA: 14,
    INTRAMUSCULAR: 15,
    INTRATECAL: 16,
    INTRAUTERINA: 17,
    INTRAVENOSA: 18,
    IRRIGACAO: 19,
    NASAL: 20,
    OFTALMICA: 21,
    OTOLOGICA: 22,
    RETAL: 23,
    SUBCUTANEA: 24,
    SUBLINGUAL: 25,
    TRANSDERMICA: 26,
    URETRAL: 27,
    VAGINAL: 28,
}